export const toQueryString = (value: unknown): string => {

  if (typeof value === 'string') {

    return value.trim();

  }

  if (Array.isArray(value) && typeof value[0] === 'string') {

    return value[0].trim();

  }

  return '';

};
